export default __webpack_public_path__ + "static/media/declaration-mgimed.bcd6b920.pdf";